import dayjs, { Dayjs } from 'dayjs'

type PickerInput = Date | string | number | Dayjs | null | undefined

/** Props that may carry a legacy Date when passed to MUI X (AdapterDayjs). */
export const DATE_PICKER_PROPS = [
  'value',
  'defaultValue',
  'minDate',
  'maxDate',
  'initialFocusedDate',
  'referenceDate',
] as const

export const DATE_TIME_PICKER_PROPS = [
  ...DATE_PICKER_PROPS,
  'minDateTime',
  'maxDateTime',
] as const

export const TIME_PICKER_PROPS = ['value', 'defaultValue', 'minTime', 'maxTime'] as const

function toValidDayjs(value: PickerInput) {
  if (value == null) {
    return value
  }

  const day = dayjs.isDayjs(value) ? value : dayjs(value)
  return day.isValid() ? day : null
}

/** Return a copy of `props` with the listed date fields coerced for AdapterDayjs. */
export function withPickerDayjs<T extends object>(props: T, ...dateKeys: string[]): T {
  const converted = { ...props } as Record<string, unknown>

  for (const key of dateKeys) {
    if (converted[key] === undefined) {
      continue
    }
    converted[key] = toValidDayjs(converted[key] as PickerInput)
  }

  return converted as T
}
